/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const headerLandingConfig = {
  headerLogo: 'https://i.ibb.co/02wVzNz/bharat-life-insurance-v2.png',
  headerLink: '/product/bharat-life-saral-jeevan-bima',
  headerTitle: 'Bharat Life Insurance',
  headerTitleStyle: {
    fontFamily: 'muli',
  },
  buttonItem: {
    name: 'Login',
    link: '/sign-in',
  },
  manualTriggerItem: {
    name: 'Manual Death Trigger',
    link: '/deathevent',
  },
  loginButton: {
    name: 'My Profile',
    link: '/my-profile',
  },
  metaData: {
    title: 'Flexible Hurricane Protection',
    description:
      'Flexible Hurricane Protection provides protection against Tropical Cyclones of strengths Tropical Storm through Category 5 Hurricane.',
    favicon: 'https://www.linkpicture.com/q/favicon_51.ico',
  },
};
